import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Dropdown from "react-bootstrap/Dropdown";
import "../../../components/admin/css/common.css";
import sweetAlert, {
  sweetStatusAlert,
  sweetConfirmAlert
} from "../../../components/common/SweetAlert.js";
import Spinner from "react-bootstrap/Spinner";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import { CircularProgress, Tooltip } from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import { passageService } from "../../../service/question/passageService.js";
import { questionEditorService } from "../../../service/assessSections/questionEditorService";
import { passageTypeService } from "../../../service/question/passageTypeService.js";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import CardHeader from "../../../components/common/CardHeader.js";
import TabList from "../../../components/common/tabs/TabList.js";
import NavItem from "../../../components/common/tabs/NavItem.js";
import config from '../../../helper/config.js';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { customerConstants } from "../../../helper/constants.js";
import { convertToRaw, EditorState, convertFromRaw } from "draft-js";
import CustomEditor from "../../../components/common/editor/CustomEditor";
import "./ManagePassageTypes.css";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

export default class extends Component {
  constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
      showModal: false,
      passage_id: "",
      title: "",
      content: "",
      description: "",
      passage_type_id: "",
      passages: [],
      passageTypes: [],
      isModified: false,
      showInsertModal: false,
      limit: 10,
      offset: 0,
      sort_column: "passage_id",
      sort_direction: "ASC",
      search_term: "",
      totalPassages: 10,
      isTableDataLoading: true,
      currentPage: 0,
      editVisibility: true,
      addVisibility: true,
      deleteVisibility: true,
      isLoading: false,
      contentEditorState: EditorState.createEmpty(),
      isContentValid: true,
    };

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllPassages, 2000);
    this.onContentEditorChange = this.onContentEditorChange.bind(this)
  }

  // Reset the form fields to initail values on update, insert, edit modal close and add modal close
  resetFormFields = () => {
    this.setState({
      title: "",
      contentEditorState: EditorState.createEmpty(),
      description: "",
      passage_type_id: "",
    });
  };

  componentDidMount() {
    this.getAllPassageTypes();
    this.fetchAllPassages();
  }

  // Creating validator instance without any custom rules
  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  getAllPassageTypes = async () => {
    this.setState({ isLoading: true });
    await passageTypeService.getAllPassageTypes()
      .then((response) => {
        if (response.success) {
          this.setState({
            passageTypes: response.data.passage_types
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Passage Types. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Failed!",
          "Error fetching Passage Types. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  getPassageTypeName(passage_type_id) {
    if (passage_type_id !== null) {
      const passage_type = this.state.passageTypes?.find(
        (passage_type) => passage_type.passage_type_id == parseInt(passage_type_id)
      );
      return passage_type?.name;
    }
    else {
      return "N/A";
    }
  }

  //fetching available passages count for pagination using specific search_term
  fetchAllPassages = async () => {
    this.setState({ isTableDataLoading: true });
    const { limit, offset, sort_column, sort_direction, search_term } = this.state;
    await passageService.getAll(limit, offset, search_term, sort_column, sort_direction)
      .then((response) => {
        if (response.success) {
          this.setState({
            passages: response.data.passages,
            totalPassages: parseInt(response.data.total_count),
          });
          this.setState({ isTableDataLoading: false });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching passages. Please refresh the screen!",
            "error"
          );
          this.setState({ isTableDataLoading: false });
        }
      })
      .catch((error) => {
        // Handle any error that occurred during the API call
        sweetStatusAlert(
          "Failed!",
          "Error fetching passages. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false }); // Set isTableDataLoading to false after data is fetched
      });
  };

  // Handle the data fetching as per the offset(page no) changes
  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllPassages();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.fetchAllPassages();
      }
    );
  };

  // handle the data fetching as per the data per page limit gets changess
  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.fetchAllPassages();
      }
    );
  };

  handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
      currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
      {
        sort_column,
        sort_direction: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.fetchAllPassages();
      }
    );
  };

  // handle search text as per the regex validation and search_term , and fetch data as per the debounce
  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  // Toggle out the state of add form modal
  toggleAddPassageModal = () => {
    this.setState((prevState) => ({
      showInsertModal: !prevState.showInsertModal,
    }));
  };

  // Toggle out the state of update form modal
  toggleUpdatePassageModal = (passage_id, title, content, description, passage_type_id) => {
    let editorStateWithExistingContent = EditorState.createEmpty();

    try {
      if (content) {
        const existingContent = JSON.parse(content);

        const contentState = convertFromRaw(
          Array.isArray(existingContent) ? existingContent[0] : existingContent
        );

        editorStateWithExistingContent = EditorState.createWithContent(contentState);
      }
    } catch (error) {
      console.error("Failed to parse passage content:", error);
    }

    this.setState((prevState) => ({
      showModal: !prevState.showModal,
      passage_id,
      title,
      contentEditorState: editorStateWithExistingContent,
      description,
      passage_type_id,
    }));
  };

  validateContentEditor = () => {
    const contentState = this.state.contentEditorState?.getCurrentContent();
    const isValid = contentState && contentState.hasText();
    this.setState({ isContentValid: isValid });
    return isValid;
  };

  onContentEditorChange = (editorState) => {
    this.setState({ contentEditorState: editorState }, () => {
      this.validateContentEditor();
    });
  };

  // Sets the value of a specific state based on the value provided to the respective element based on its assigned name
  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
  };

  handleChangePassageType = (event) => {
    event.preventDefault();
    this.setState({ passage_type_id: event.target.value });
  };

  // Pop up a sweet alert on edit or add modal and change its toggle state based on the input given to that sweet alert
  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.hideMessages();
      this.validator.purgeFields();
      this.resetFormFields();
      toggleFunction();
    }
  };

  // Make post request based on the fields validity and create the passages based on the state
  handleSubmit = async (event) => {
    event.preventDefault();

    const isContentValid = this.validateContentEditor();
    const isFormValid = this.validator.allValid() && isContentValid;

    if (!isFormValid) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      let created_by = sessionStorage.getItem("manage_user_id");

      let content = JSON.stringify([convertToRaw(this.state.contentEditorState.getCurrentContent())]);

      const { title, description, passage_type_id } = this.state;
      const newPassage = { title: title, content: content, description: description, passage_type_id: passage_type_id, created_by: created_by };

      await passageService.addPassage(newPassage)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            questionEditorService.clearQuestionMetadataCache();
            this.setState({ showInsertModal: false });
            sweetStatusAlert("Success!", response.message.success, "success");
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchAllPassages();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch(() => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Failed !", "Unable to create new passage", "error");
        });
    }
  };

  // Make put request based on the fields validity and updation of necessary states
  handleUpdateSubmit = async (event) => {
    event.preventDefault();

    const isContentValid = this.validateContentEditor();
    const isFormValid = this.validator.allValid() && isContentValid;

    if (!isFormValid) {
      this.validator.showMessages();
      this.forceUpdate();
    } else {
      this.setState({ isLoading: true });

      let created_by = sessionStorage.getItem("manage_user_id");

      const passageItem = {
        title: this.state.title,
        content: JSON.stringify([convertToRaw(this.state.contentEditorState.getCurrentContent())]),
        description: this.state.description,
        created_by: created_by,
        passage_type_id: this.state.passage_type_id,
      };

      const passageId = this.state.passage_id;
      await passageService.updatePassage(passageItem, passageId)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            questionEditorService.clearQuestionMetadataCache();
            this.setState({ showModal: false });
            sweetStatusAlert(
              "Success!",
              "Passage information updated successfully..!",
              "success"
            );
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.fetchAllPassages();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert(
            "Failed !",
            "Unable to update the passage information",
            "error"
          );
        });
    }
  };

  handleDeletePassage = (obj) => {
    sweetConfirmAlert().then(() => {
      this.setState({ isLoading: true });
      passageService.deletePassage(obj)
        .then((response) => {
          this.setState({ isLoading: false });
          if (response.success) {
            questionEditorService.clearQuestionMetadataCache();
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllPassages();
          } else {
            sweetStatusAlert("Failed!", response.message, "error");
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          sweetStatusAlert("Oops!", "Error while deleting the passage", "info");
        });
    });
  };

  //Rendering the necessary components based on the logic
  render() {
    const {
      limit,
      passages,
      totalPassages,
      isTableDataLoading,
      currentPage,
      editVisibility,
      addVisibility,
      deleteVisibility,
      isLoading,
    } = this.state;
    this.validator.purgeFields();
    return (
      <>
        <div className="passage-types-container">
          <CardHeader>
            <div className="d-flex align-items-center justify-content-between w-100 flex-wrap py-2">
              <div>
                <h3 className="text-nowrap mb-0">Question Passages</h3>
              </div>

              <div>
                {addVisibility && (
                  <button
                    className="btn w-auto btn-clean d-inline-flex align-items-center create-btn big-action-btn passage-add-btn"
                    onClick={() => this.toggleAddPassageModal(true)}
                  >
                    <span className="btn btn-link-primary font-weight-bolder font-size-base text-nowrap">Add Passage</span>
                  </button>
                )}
              </div>
            </div>

            <div className="passage-top-controls-grid">

              {/* Inline nav tabs copy (shows inside the controls grid for Manage Passages) */}
              <div className="passage-tabs-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                <TabList>
                  <NavItem
                    className={`nav-link ${this.props.activeTab === 'Passage Types' ? 'active' : ''}`}
                    id="passage-types-tab-1-passages-page"
                    href="#passage-types-1"
                    dataToggle="tab"
                    iconName="flaticon2-list-2"
                    tabName="Passage Types"
                    onClick={() => (this.props.setActiveTab ? this.props.setActiveTab('Passage Types') : null)}
                  />
                  <NavItem
                    className={`nav-link ${this.props.activeTab === 'Passages' ? 'active' : ''}`}
                    id="passages-tab-1-passages-page"
                    href="#passages-1"
                    dataToggle="tab"
                    iconName="flaticon2-file"
                    tabName="Passages"
                    onClick={() => (this.props.setActiveTab ? this.props.setActiveTab('Passages') : null)}
                  />
                </TabList>
              </div>


              {/* 2. Search Field - Middle Left */}
              <div className="passage-search-wrapper">
                <Form.Group controlId="exampleForm.ControlInput1" className="mb-0">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    onChange={this.handleSearch}
                    isInvalid={this.state.searchError}
                    className="w-100"
                  />
                </Form.Group>
              </div>

              {/* 3. Number of Passages - Middle Right */}
              <div className="passage-count-wrapper">
                <div className="sort-button no-of-items">
                  <span className="sort-by-label">Total Passages</span>
                  <span className="sort-current">
                    {isTableDataLoading ? (
                      <CircularProgress size={16} />
                    ) : (
                      totalPassages
                    )}
                  </span>
                </div>
              </div>

              {/* 4. Sort Dropdown - Right Edge */}
              <div className="passage-sort-wrapper">
                <Dropdown className="sort-dropdown">
                  <Dropdown.Toggle
                    variant="light"
                    id="sort-dropdown-passages"
                    className={`sort-button ${this.state.sort_direction === 'DESC' ? 'desc' : ''}`}
                  >
                    <span className="sort-by-label">Sort By:</span>
                    <span className="sort-current">
                      {this.state.sort_column === "passage_id" && "ID"}
                      {this.state.sort_column === "title" && "Title"}
                      {this.state.sort_column === "description" && "Description"}
                      {this.state.sort_column === "passage_type_id" && "Passage Type"}
                    </span>
                    {this.state.sort_direction === 'ASC' ? (
                      <ArrowUpwardIcon sx={{ fontSize: 16, color: '#5458AF', marginLeft: '4px' }} />
                    ) : (
                      <ArrowDownwardIcon sx={{ fontSize: 16, color: '#5458AF', marginLeft: '4px' }} />
                    )}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="sort-menu">
                    <div className="menu-header">Sort By</div>
                    <div className="menu-body">
                      <Dropdown.Item
                        active={this.state.sort_column === "passage_id"}
                        onClick={() => this.handleSortChange("passage_id")}
                      >
                        ID
                        {this.state.sort_column === "passage_id" && <span className="checkmark">✓</span>}
                      </Dropdown.Item>
                      <Dropdown.Item
                        active={this.state.sort_column === "title"}
                        onClick={() => this.handleSortChange("title")}
                      >
                        Title
                        {this.state.sort_column === "title" && <span className="checkmark">✓</span>}
                      </Dropdown.Item>
                      <Dropdown.Item
                        active={this.state.sort_column === "description"}
                        onClick={() => this.handleSortChange("description")}
                      >
                        Description
                        {this.state.sort_column === "description" && <span className="checkmark">✓</span>}
                      </Dropdown.Item>
                      <Dropdown.Item
                        active={this.state.sort_column === "passage_type_id"}
                        onClick={() => this.handleSortChange("passage_type_id")}
                      >
                        Passage Type
                        {this.state.sort_column === "passage_type_id" && <span className="checkmark">✓</span>}
                      </Dropdown.Item>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </CardHeader>

          {/* Card Section */}
          <div>
            {isLoading && (
              <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isTableDataLoading ? (
              <div
                className="loading-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  minHeight: "60vh",
                }}
              >
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : passages.length > 0 ? (
              <div className="passage-cards-container">
                {passages.map((passageItem) => (
                  <div key={`passage-card-${passageItem.passage_id}`} className="passage-type-card">
                    <div className="passage-card-content passage-card-content--passage">
                      <div className="passage-left-section">
                        <div className="passage-card-title-row">
                          <span className="passage-card-id">#{passageItem.passage_id}</span>
                          <Tooltip title={passageItem.title || "Untitled Passage"} placement="bottom-start" arrow>
                            <span className="passage-card-name passage-card-name--passage">
                              {passageItem.title || "Untitled Passage"}
                            </span>
                          </Tooltip>
                        </div>

                        <div className="passage-meta-info passage-meta-info--stacked">
                          <span className="passage-card-badge">
                            {passageItem.passage_type_id !== null
                              ? this.getPassageTypeName(passageItem.passage_type_id)
                              : "N/A"}
                          </span>
                          <span className="passage-description-text passage-description-text--passage">
                            {passageItem.description || "No description available"}
                          </span>
                        </div>
                      </div>

                      {(editVisibility || deleteVisibility) && (
                        <div className="passage-actions-group">
                          {editVisibility && (
                            <Tooltip title="Edit Details" placement="top" arrow>
                              <button
                                type="button"
                                className="passage-action-btn edit-btn flaticon-edit-icon"
                                onClick={() =>
                                  this.toggleUpdatePassageModal(
                                    passageItem.passage_id,
                                    passageItem.title,
                                    passageItem.content,
                                    passageItem.description,
                                    passageItem.passage_type_id,
                                  )
                                }
                              />
                            </Tooltip>
                          )}
                          {deleteVisibility && (
                            <Tooltip title="Delete" placement="top" arrow>
                              <button
                                type="button"
                                className="passage-action-btn delete-btn flaticon-delete"
                                onClick={() => this.handleDeletePassage(passageItem)}
                              />
                            </Tooltip>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}

                <MaterialCustomTablePagination
                  totalCount={totalPassages}
                  currentPage={currentPage}
                  limit={limit}
                  handlePageChange={this.handlePageChange}
                  handleRowsPerPageChange={this.handleRowsPerPageChange}
                  handlePageOffsetChange={this.handlePageOffsetChange}
                  offset={this.state.offset}
                  rowsPerPageOptions={[5, 10, 20]}
                />
              </div>
            ) : (
              <div className="no-passages-container">
                <div className="no-passages-inner">
                  <i className="fas fa-inbox no-passages-icon" aria-hidden="true"></i>
                  <span className="no-passages-text">No Passages Available!</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <Modal
          className="passage-modal"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showInsertModal}
          onHide={() =>
            this.handleSweetAlert(this.toggleAddPassageModal, "showInsertModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Create New Passage</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="9"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Title*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the title..."
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "title",
                    this.state.title,
                    "required|max:30",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The title field is required.",
                        max: "The title should not be greater than 30 characters.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Select Passage Type*</Form.Label>
                  <Form.Select
                    id="passage_type"
                    value={this.state.passage_type_id || ""}
                    onChange={this.handleChangePassageType}
                    className="form-control"
                  >
                    <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                    {this.state.passageTypes.map((option, index) => (
                      <option key={index} value={option.passage_type_id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                  {this.validator.message(
                    "passage_type",
                    this.state.passage_type_id,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Form.Group>
              </Row>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="12"
                  controlId="exampleForm.ControlInput1"
                  className="passage-editor-group"
                >
                  <Form.Label>Content*</Form.Label>
                  <div
                    className="passage-editor-wrapper"
                  >
                    <CustomEditor
                      editorState={
                        this.state.contentEditorState
                          ? this.state.contentEditorState
                          : null
                      }
                      onEditorStateChange={this.onContentEditorChange}
                    />
                  </div>
                </Form.Group>
                {!this.state.isContentValid && (
                  <div className="text-danger mt-2 mb-4" style={{ paddingLeft: "2px" }}>The content field is required.</div>
                )}
              </Row>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="9"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Description*</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    type="text"
                    name="description"
                    placeholder="Type description here..."
                    value={this.state.description}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "description",
                    this.state.description,
                    "required|max:120",
                    {
                      className: "text-danger",
                      messages: {
                        max: "The passage type description should not be greater than 120 characters.",
                        required: "The passage description field is required.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleSubmit}
            >
              Save changes
            </Button>
            <Button
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.handleSweetAlert(
                  this.toggleAddPassageModal,
                  "showInsertModal"
                )
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="passage-modal"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.showModal}
          onHide={() =>
            this.handleSweetAlert(this.toggleUpdatePassageModal, "showModal")
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Update Passage Information</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="9"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Title*</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter the title..."
                    name="title"
                    value={this.state.title}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "title",
                    this.state.title,
                    "required|max:30",
                    {
                      className: "text-danger",
                      messages: {
                        required: "The title field is required.",
                        max: "The title should not be greater than 30 characters.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="6"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Select Passage Type*</Form.Label>
                  <Form.Select
                    id="passage_type"
                    value={this.state.passage_type_id || ""}
                    onChange={this.handleChangePassageType}
                    className="form-control"
                  >
                    <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                    {this.state.passageTypes.map((option, index) => (
                      <option key={index} value={option.passage_type_id}>
                        {option.name}
                      </option>
                    ))}
                  </Form.Select>
                  {this.validator.message(
                    "passage_type",
                    this.state.passage_type_id,
                    "required",
                    {
                      className: "text-danger",
                    }
                  )}
                </Form.Group>
              </Row>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="12"
                  controlId="exampleForm.ControlInput1"
                  className="passage-editor-group"
                >
                  <Form.Label>Content*</Form.Label>
                  <div
                    className="passage-editor-wrapper"
                  >
                    <CustomEditor
                      editorState={
                        this.state.contentEditorState
                          ? this.state.contentEditorState
                          : null
                      }
                      onEditorStateChange={this.onContentEditorChange}
                    />
                  </div>
                </Form.Group>
                {!this.state.isContentValid && (
                  <div className="text-danger mt-2 mb-4" style={{ paddingLeft: "2px" }}>The content field is required.</div>
                )}
              </Row>
              <Row className="my-5">
                <Form.Group
                  as={Col}
                  md="9"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Description*</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    type="text"
                    name="description"
                    placeholder="Type description here..."
                    value={this.state.description}
                    onChange={this.handleChange}
                  />
                  {this.validator.message(
                    "description",
                    this.state.description,
                    "required|max:120",
                    {
                      className: "text-danger",
                      messages: {
                        max: "The passage type description should not be greater than 120 characters.",
                        required: "The passage description field is required.",
                      },
                    }
                  )}
                </Form.Group>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="modal-btn"
              variant="primary"
              style={addBtnStyle}
              onClick={this.handleUpdateSubmit}
            >
              Save changes
            </Button>
            <Button
              className="modal-btn"
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.handleSweetAlert(this.toggleUpdatePassageModal, "showModal")
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
